import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { ClipboardCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { apiGetWorkflowTaskCount } from "@/lib/api";

export function TasksBadge() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data } = useQuery({
    queryKey: ["workflow-task-count"],
    queryFn: apiGetWorkflowTaskCount,
    refetchInterval: 30_000,
    staleTime: 15_000,
  });

  const count = data?.count ?? 0;

  return (
    <Button
      variant="ghost"
      size="icon"
      className="relative"
      onClick={() => navigate("/my-tasks")}
      title={t("nav.myTasks")}
    >
      <ClipboardCheck className="h-5 w-5" />
      {count > 0 && (
        <Badge
          variant="destructive"
          className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 text-xs"
        >
          {count > 99 ? "99+" : count}
        </Badge>
      )}
      <span className="sr-only">{t("nav.myTasks")}</span>
    </Button>
  );
}
